import { baseUrl, GetHeaders, handleResponse, handleError } from "../common/ApiUtils";

const apiUrl = baseUrl + "reports";

export function getYearsWithData() {
  let data = fetch(`${apiUrl}/years`, GetHeaders()).then(handleResponse).catch(handleError);
  return data;
}

export function getMonths(year) {
  return fetch(`${apiUrl}/months/${year}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getEmployeeRevShareByMonth(year, isManager) {
  return fetch(`${apiUrl}/employeesbymonth?year=${year}${isManager ? "&manager=true" : ""}`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getEmployeeRevShareYTD(year, isManager) {
  return fetch(`${apiUrl}/employeesytd?year=${year}${isManager ? "&manager=true" : ""}`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getSubAccountRevShareByMonth(year, isManager) {
  return fetch(`${apiUrl}/subaccountbymonth?year=${year}${isManager ? "&manager=true" : ""}`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getSubAcountRevShareYTD(year, isManager) {
  return fetch(`${apiUrl}/subaccountsytd?year=${year}${isManager ? "&manager=true" : ""}`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getCashOutRequestsByMonth(year, isManager) {
  return fetch(`${apiUrl}/cashOutRequestsByMonth?year=${year}${isManager ? "&manager=true" : ""}`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}
